export function getStoredToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return (
    localStorage.getItem('token') ||
    localStorage.getItem('authToken') ||
    localStorage.getItem('accessToken')
  );
}

export function withAuthHeaders(headers: HeadersInit = {}): HeadersInit {
  const token = getStoredToken();
  if (!token) {
    return headers;
  }
  return {
    ...headers,
    Authorization: `Bearer ${token}`
  };
}

export function createAuthRequestInit(options: RequestInit = {}, includeJson = false): RequestInit {
  const baseHeaders: HeadersInit = includeJson ? { 'Content-Type': 'application/json' } : {};
  const mergedHeaders: HeadersInit = {
    ...baseHeaders,
    ...(options.headers || {})
  };

  return {
    credentials: 'include',
    ...options,
    headers: withAuthHeaders(mergedHeaders)
  };
}

